import Local from '../classes/local';

export default function getLocale() {
    return Local.getItem('language') === 'Spanish' ? 'es-mx' : 'en-us';
}
